import React from "react";
import { motion } from "framer-motion";
import { childrenVariant } from "../../../../constants";
import { isLevelAttained } from "../../../../utils";
import styles from "./levelLine.module.scss";
const LevelLine = ({ level, inhibitors, improvementsText }) => {
    const isAttained = isLevelAttained(inhibitors, level);
    if (isAttained)
        return (React.createElement(motion.div, { variants: childrenVariant, className: `${styles["attained-level-line"]}` }));
    else
        return (React.createElement(motion.div, { variants: childrenVariant, className: styles["level-improvements"] },
            improvementsText,
            React.createElement("div", { className: styles["improvements-line"] })));
};
export default LevelLine;
//# sourceMappingURL=LevelLine.js.map